import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@arcadeai/design-system/components/ui/atoms/card";
import { useGetTools } from "@/app/tools/api/hooks";
import { columns } from "@/app/tools/data-table/columns";
import { ToolsTable } from "@/app/tools/data-table/tools-table";
import type { Tool } from "@/app/tools/types";

export const Tools = ({ provider_id }: { provider_id: string }) => {
  const { data: tools } = useGetTools();

  const filteredTools = tools?.items
    .filter((tool: Tool) => tool.requirements?.authorization) // First filter out tools that don't have authorization requirements
    .filter((tool: Tool) => {
      // Then filter out tools that don't have the correct provider_id
      return (
        tool.requirements?.authorization?.provider_id?.toLowerCase() ===
        provider_id?.toLowerCase()
      );
    });

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="font-semibold text-lg">Tools</CardTitle>
        <CardDescription className="text-sm">
          Tools and actions available with your {provider_id} integration
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ToolsTable
          columns={columns}
          data={filteredTools}
          stickyColumnBg="card"
        />
      </CardContent>
    </Card>
  );
};
